import { render, staticRenderFns } from "./AppFormStatusChip.vue?vue&type=template&id=4baf447e&"
import script from "./AppFormStatusChip.vue?vue&type=script&lang=js&"
export * from "./AppFormStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports